import React, { useCallback, useState, useEffect, useMemo } from 'react'
import NodePresenter from '../../api/nodePresenter'
import ViewStatusNodes from '../../components/ViewStatusNodes'
import { Tree, Status, noop, useWindowContext } from '@iqueue/ui-kit'
import useTranslate, { t } from '../../hooks/useTranslate'

export default function StatePage() {
  const [nodes, setNodes] = useState([])
  const locale = useTranslate()
  const { togglePaddings, setTitle } = useWindowContext()
  const translatedTitle = useMemo(() => t('menu.state'), [locale])

  const handleChangeNode = useCallback(async () => {
    await NodePresenter.treeStates({ depth: 500 }).then(setNodes)
  }, [])

  const buildTree = useCallback((nodes) => {
    const leaf = (nodes) => {
      return nodes.map((node) => {
        const children = leaf(node.children || [])

        const sensorChildren = (node.sensors || []).map((sensor) => {
          return {
            id: sensor.id,
            type: 'SENSOR',
            status: sensor.status,
            sensorType: sensor.type,
            value: sensor.state?.value,
            temperature: sensor.state?.temperature,
            voltage: sensor.state?.voltage,
            name: `${ t(`type.sensor.${ sensor.type }`) }`,
            children: [],
          }
        })

        return {
          id: node.id,
          expanded: true,
          status: node.status,
          type: node.type,
          ...node,
          children: [...children, ...sensorChildren],
        }
      })
    }

    return leaf(nodes)
  }, [])

  useEffect(() => {
    handleChangeNode().catch((err) => console.error(err))
  }, [])

  useEffect(() => {
    setTitle(translatedTitle)
    togglePaddings(false)
  }, [translatedTitle])

  return <div className="tree-main">
    <Tree
      selectMode="none"
      entries={ buildTree(nodes) }
      render={ (node) => {
        return <div className="node-tree" key={ node.id }>
          <>
            <b>{ node.type !== 'SENSOR' ? node.name : `${ t('notice.table.sensorType') }: ${ node.name }` }</b>
            <span>&nbsp;
              { node.type !== 'SENSOR' ? <div>
                <div/>
                { t('uploadExcel.status') }:&nbsp;
                <ViewStatusNodes item={ node }/>
                <div/>
              </div> : <>
                <br/>
                <div/>
                { t('sensorInfo.sensorStatus') }:&nbsp;
                <Status
                  inline={ node.status !== 'NO_SIGNAL' }
                  weak
                  warning={ node.status === 'TECH_WORKS' }
                  error={ node.status === 'NO_SIGNAL' || node.status === 'SHORT_CIRCUIT' || node.status === 'NO_SENSOR_SIGNAL' || node.status === 'UNKNOWN_UNIT' || node.status === 'INVALID_DRIVER' }
                >
                  { t(`status.sensor.${ node.status }`) }
                </Status>
                <div/>
              </> }
            </span>
            <div>
              { node.type !== 'SENSOR' ? (
                <span>{ t('uploadExcel.type') }: <b>{ t(`type.node.${ node.type }`) }</b></span>
              ) : (
                <span>{ t('sensorInfo.lastData') }:{ ' ' }
                  <b>
                    { Number(node.value).toFixed(2) }
                    { node.value != null && node.sensorType?.startsWith('PRESSURE') && ' кГс/см²' }
                    { node.value != null && node.sensorType === 'TEMPERATURE' && ' °C' }
                  </b>
                </span>
              ) }
            </div>
            <div>
              { node.type === 'SENSOR' && <span>{ t('type.sensor.TEMPERATURE') }: <b>{ node.temperature }</b></span> }
            </div>
            <div>
              { node.type === 'SENSOR' && <span>{ t('sensorInfo.voltage') }: <b>{
                `${ (node.voltage / 1000).toFixed(2) } V`
              }
              </b>
              </span> }
            </div>
          </>
        </div>
      } }
    />
  </div>
}
